export enum OfflineDocStatusEnum {
    NOTSYNCED = 0,
    SYNCED = 1,
}